import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { faqs } from "@/mocks/home";

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="section-anchor bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="FAQ"
          title="常见问题"
          desc="关于本站内容范围、分类方式与浏览方式的一些说明。"
          align="center"
        />

        <div className="mt-10 max-w-3xl mx-auto space-y-3">
          {faqs.map((item, index) => {
            const isOpen = open === index;
            return (
              <div
                key={item.q}
                className={`rounded-lg border bg-background-50 transition-colors ${
                  isOpen ? "border-primary-300" : "border-background-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : index)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center gap-4 px-5 py-4 text-left"
                >
                  <span className="font-heading text-base md:text-lg font-bold text-foreground-950 flex-1">
                    {item.q}
                  </span>
                  <i
                    className={`shrink-0 text-lg text-primary-600 transition-transform ${
                      isOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"
                    }`}
                  />
                </button>
                {isOpen && (
                  <p className="px-5 pb-5 text-sm md:text-base leading-8 text-foreground-700">
                    {item.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}